import { isSignal, Signal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { isObservable, Observable } from 'rxjs';
import { DataProvider, DataProviderConfig, EntityType } from './types';

export function localDataProvider<Entity extends EntityType>(
  data: Entity[] | Signal<Entity[]> | Observable<Entity[]>,
  config?: DataProviderConfig<Entity>,
): DataProvider<Entity> {
  let _data: Signal<Entity[]>;
  if (isObservable(data)) {
    _data = toSignal(data, { initialValue: [] });
  } else if (!isSignal(data)) {
    _data = signal(data);
  } else {
    _data = data;
  }
  const loading = signal(false);

  return {
    loading,
    data: _data,
    supportSearch: false,
    setSearch() {
      // not required here
    },
    refresh() {
      // not required here
    },
    config: {
      valueKey: 'value',
      labelKey: 'label',
      ...config,
    },
  };
}
